import { handleServiceError } from '../helpers/app';
import { ResponseObject } from '../interfaces/App';
import Company from '../interfaces/Company';
import apiRequest from './apiService';

const createCompanyIfNotExisting = async (id: string, data: any = {}) => {
  const existingCompany = await getCompany(id);
  if (existingCompany) return;

  const newUser = await createCompany(data);
  return newUser;
};

const createCompany = async (data: any = {}) => {
  try {
    const result = await apiRequest(
      'admin',
      'POST',
      '/company/create_company',
      data
    );
    return result;
  } catch (error: any) {
    handleServiceError(error, 'company');
  }
};

const getCompany = async (id: string) => {
  try {
    const result: ResponseObject = await apiRequest(
      'admin',
      'GET',
      `/company/get_company/${id}`
    );
    return result;
  } catch (error: any) {
    handleServiceError(error, 'company');
  }
};

const updateCompany = async (id: string, data: Company) => {
  try {
    const result = await apiRequest(
      'admin',
      'PUT',
      `/company/update_company/${id}`,
      data
    );
    return result;
  } catch (error: any) {
    handleServiceError(error, 'company');
  }
};

const deleteCompany = async (id: string) => {
  try {
    const result = await apiRequest(
      'admin',
      'DELETE',
      `/company/delete_object/${id}`
    );
    return result;
  } catch (error: any) {
    handleServiceError(error, 'company');
  }
};

export {
  createCompanyIfNotExisting,
  createCompany,
  getCompany,
  updateCompany,
  deleteCompany,
};
